import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBonusHistory } from "./cl_BonusHistorySlice";
import PaginationComponent from "../common/PaginationComponent";

const BonusHistory = () => {
  const dispatch = useDispatch();
  const { bonusHistoryData } = useSelector((state) => state?.bonusHistory);
  const userDetails = useSelector((state) => state.signIn.userDetails);
  useEffect(() => {
    dispatch(fetchBonusHistory(userDetails?.userId));
  }, []);
  useEffect(() => {
    // console.log(bonusHistoryData, "bonusHistoryData=====");
  }, [bonusHistoryData]);
  return (
    <React.Fragment>
      <div className="SB-myAccountSection-container SB-bonusHistory">
        <div className="SB-pageHeader">
          <div className="SB-pageHeader-title">Bonus History</div>
        </div>
        <div className="SB-transactionBox">
          <div className="SB-transaction-item">
            <div className="SB-transaction__col SB-col1">
              <div className="SB-transaction-dateID">
                <div className="SB-transactionID">ID: 123abc11</div>
                <div className="SB-transactionDate">5/11/2022 15:36:30</div>
              </div>
            </div>
            <div className="SB-transaction__col SB-col2">
              <div className="">
                <div className="SB-transactionType">Freebet</div>
                <div className="SB-transactionMethod">Freebet awarded</div>
              </div>
              <div className="SB-transaction-statusAmount">
                <div className="SB-transactionAmount SB-error">INR 100.00</div>
              </div>
            </div>
          </div>
          <div className="SB-transaction-item">
            <div className="SB-transaction__col SB-col1">
              <div className="SB-transaction-dateID">
                <div className="SB-transactionID">ID: 123sdif01</div>
                <div className="SB-transactionDate">6/11/2022 15:36:30</div>
              </div>
            </div>
            <div className="SB-transaction__col SB-col2">
              <div className="">
                <div className="SB-transactionType">Freebet</div>
                <div className="SB-transactionMethod">Bet placed</div>
              </div>
              <div className="SB-transaction-statusAmount">
                <div className="SB-transactionAmount SB-error">INR 100.00</div>
              </div>
            </div>
          </div>
          <div className="SB-transaction-item">
            <div className="SB-transaction__col SB-col1">
              <div className="SB-transaction-dateID">
                <div className="SB-transactionID">ID: bjpsdif15</div>
                <div className="SB-transactionDate">7/11/2022 15:36:30</div>
              </div>
            </div>
            <div className="SB-transaction__col SB-col2">
              <div className="">
                <div className="SB-transactionType">Deposit Bonus</div>
                <div className="SB-transactionMethod">Bonus Unlocked</div>
              </div>
              <div className="SB-transaction-statusAmount">
                <div className="SB-transactionAmount SB-error">INR 500.00</div>
              </div>
            </div>
          </div>
          <div className="SB-transaction-item">
            <div className="SB-transaction__col SB-col1">
              <div className="SB-transaction-dateID">
                <div className="SB-transactionID">ID: psidf419</div>
                <div className="SB-transactionDate">7/12/2022 15:36:30</div>
              </div>
            </div>
            <div className="SB-transaction__col SB-col2">
              <div className="">
                <div className="SB-transactionType">Signup Bonus</div>
                <div className="SB-transactionMethod">Bonus Unlocked</div>
              </div>
              <div className="SB-transaction-statusAmount">
                <div className="SB-transactionAmount SB-error">INR 500.00</div>
              </div>
            </div>
          </div>
        </div>
        <PaginationComponent />
      </div>
    </React.Fragment>
  );
};

export default BonusHistory;
